import React from 'react';
// import QRCode from 'react-qr-code';
import QRCode from 'react-qrcode-logo'

export default ({valToRender}) => {
    if (!valToRender) {
        return null;
    }
    return (
        <div>
            <QRCode value={valToRender} />
        </div>
    )
}

